import { useState } from 'react';
import {
  Typography, TextField, Button, Table, TableBody,
  TableCell, TableHead, TableRow, Box, FormControl,
  InputLabel, Select, MenuItem
} from '@mui/material';
import axios from 'axios';

const API = 'https://attend.zventures.in';

const EmployeeManagement = ({ employees, setEmployees, locations }) => {
  const [form, setForm] = useState({ id: '', name: '', phone: '', location: '' });
  const [search, setSearch] = useState('');

  const addEmployee = async () => {
    if (!form.id || !form.name || !form.location) return;
    try {
      const token = localStorage.getItem('token');
      const res = await axios.post(`${API}/api/employees`, form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setEmployees(prev => [...prev, res.data]);
      setForm({ id: '', name: '', phone: '', location: '' });
    } catch (err) {
      console.error('Error adding employee:', err);
    }
  };

  const removeEmployee = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API}/api/employees/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setEmployees(prev => prev.filter(e => e.id !== id));
    } catch (err) {
      console.error('Error removing employee:', err);
    }
  };

  const fullName = (emp) => emp.name || '';

  const filtered = (employees || []).filter(emp =>
    fullName(emp).toLowerCase().includes(search.toLowerCase()) ||
    (emp.phone || '').includes(search) ||
    (emp.id || '').toLowerCase().includes(search.toLowerCase()) ||
    (emp.location || '').toLowerCase().includes(search.toLowerCase())
  );

  const locationNames = (locations || []).map(l => l.name);
  const colStyle = { minWidth: 120 };

  return (
    <Box sx={{ background: 'linear-gradient(to bottom right,#e6f0f9,#e6f0f9)', borderRadius: '10px', p: 3, mb: '5%' }}>
      <Typography variant="h5" sx={{ mb: 2, fontWeight: 400 }}>Admin Panel – Manage Employees</Typography>

      {/* Add form */}
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 3 }}>
        <TextField label="Employee Code"  value={form.id}
          onChange={e => setForm({ ...form, id: e.target.value })}
          InputProps={{ sx: { backgroundColor: 'white' } }} sx={{ minWidth: 150 }} />
        <TextField label="Full Name" value={form.name}
          onChange={e => setForm({ ...form, name: e.target.value })}
          InputProps={{ sx: { backgroundColor: 'white' } }} sx={{ minWidth: 150 }} />

        <TextField label="Phone" value={form.phone}
          onChange={e => setForm({ ...form, phone: e.target.value })}
          InputProps={{ sx: { backgroundColor: 'white' } }} sx={{ minWidth: 140 }} />
        <FormControl sx={{ minWidth: 160, backgroundColor: 'white' }}>
          <InputLabel>Location</InputLabel>
          <Select value={form.location} onChange={e => setForm({ ...form, location: e.target.value })} label="Location">
            {locationNames.map(l => <MenuItem key={l} value={l}>{l}</MenuItem>)}
          </Select>
        </FormControl>
        <Button variant="contained" onClick={addEmployee}>Add Employee</Button>
      </Box>

      {/* Search */}
      <TextField label="Search Employees" value={search}
        onChange={e => setSearch(e.target.value)} fullWidth
        InputProps={{ sx: { backgroundColor: 'white' } }} sx={{ mb: 3 }} />

      {/* Tables by location */}
      {locationNames.map(loc => {
        const locEmps = filtered.filter(e => e.location === loc);
        return (
          <Box key={loc} sx={{ borderRadius: 2, backgroundColor: '#ffffffcc', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', p: 2, mb: 3 }}>
            <Typography variant="h6" sx={{ mb: 1, fontWeight: 300, color: '#1e3a8a' }}>
              📍 {loc} Employees
            </Typography>
            <Table>
              <TableHead>
                <TableRow sx={{ background: '#f0f4ff' }}>
                  <TableCell style={colStyle}><strong>Code</strong></TableCell>
                  <TableCell style={colStyle}><strong>Full Name</strong></TableCell>
                  <TableCell style={colStyle}><strong>Phone</strong></TableCell>
                  <TableCell style={colStyle}><strong>Location</strong></TableCell>
                  <TableCell><strong>Action</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {locEmps.length > 0 ? locEmps.map(emp => (
                  <TableRow key={emp.id}>
                    <TableCell>{emp.id}</TableCell>
                    <TableCell>{emp.name}</TableCell>
                    <TableCell>{emp.phone}</TableCell>
                    <TableCell>{emp.location}</TableCell>
                    <TableCell>
                      <Button color="error" variant="outlined" size="small" onClick={() => removeEmployee(emp.id)}>
                        Remove
                      </Button>
                    </TableCell>
                  </TableRow>
                )) : (
                  <TableRow><TableCell colSpan={6} align="center" sx={{ color: '#999' }}>No employees in this location</TableCell></TableRow>
                )}
              </TableBody>
            </Table>
          </Box>
        );
      })}
    </Box>
  );
};

export default EmployeeManagement;